import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../../app.service';

@Component({
  selector: 'app-husband',
  templateUrl: './husband.component.html',
  styleUrls: ['./husband.component.scss']
})
export class HusbandEligibilityComponent implements OnInit {

  deceased = this.appState.get();
  	all_conditions: boolean = false;
	
	constructor(public appState: AppService, public router: Router) {
		this.appState = this.appState;
	}

	

	// Eligibility Check
	eligibilityCheck(deceased: any = false) {
		if( deceased ) {
			this.deceased = deceased;
		}

		if( this.deceased.gender == "Female" && this.deceased.martial_status != "Never Married" && this.deceased.martial_status != "Other" && this.deceased.martial_status != "" ) {
	      var this_husband = this.deceased['husband'];

	      // If All empty Continue without Checking
	      if( this_husband.muslim == "" && this_husband.deceased_killer == "" && this_husband.free_person == "true" ) {
	        this.deceased['husband'].eligibility = "";
	        return undefined;
	      
	      } else {
	        // Otherwise Check
	        if( this_husband.muslim == "true" && this_husband.deceased_killer == "true" && this_husband.free_person == "true" ) {
	          
	          this.deceased['husband'].eligibility = "true";
	          this.all_conditions = true;
	        
	        } else {
	          
	          this.deceased['husband'].eligibility = "false";
	          if( this.all_conditions == false )  {
	            this.all_conditions = false;
	          }
	        }
	      }

	      return this.all_conditions;
	    }
	}


	// Back Button
	back(event) {
		this.router.navigate(['level1-inheritors']);		
		event.preventDefault();
	}

	// Next Button is clicked
	next(event) {
		// Eligibility Test
		this.eligibilityCheck();

		// Save
		this.appState.set(this.deceased);

    	// Redirect to Results Page
		this.router.navigate(['level1-inheritors']);	
	    
		event.preventDefault();

	}

  ngOnInit() {
  }

}
